(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-chile-rut"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-chile-rut')) {
    customElements.define('cart-chile-rut', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.toggle = this.querySelector('[data-chile-toggle]');
        this.rut = this.querySelector('[data-chile-rut]');
        this.form = this.closest('form');
        this.addEventListener('input', () => this.sync(), options);
        this.addEventListener('change', () => this.save().catch(() => {}), options);
        this.form.addEventListener('submit', async event => {
          if (this.ready) {
            this.ready = false;
            return;
          }
          event.preventDefault();
          if (this.pendingSubmit) return;
          this.sync();
          if (!this.form.reportValidity()) return;
          this.pendingSubmit = true;
          try {
            await this.save();
            this.ready = true;
            this.form.requestSubmit(event.submitter || undefined);
          } catch {
            this.showError();
          } finally {
            this.pendingSubmit = false;
          }
        }, options);
        this.form.querySelectorAll('a').forEach(link => {
          if (new URL(link.href, location.href).pathname === new URL(this.form.action).pathname) {
            link.addEventListener('click', async event => {
              event.preventDefault();
              try { await this.save(); location.assign(link.href); } catch { this.showError(); }
            }, options);
          }
        });
        this.sync();
      }
      disconnectedCallback() { this.controller.abort(); }
      sync() {
        const enabled = this.toggle.checked;
        const value = enabled ? this.rut.value : '';
        document.querySelectorAll('cart-chile-rut').forEach(component => {
          const toggle = component.querySelector('[data-chile-toggle]');
          const rut = component.querySelector('[data-chile-rut]');
          toggle.checked = enabled;
          rut.value = value;
          rut.required = enabled;
          rut.setCustomValidity(enabled && !value.trim() ? rut.dataset.requiredMessage : '');
          component.querySelector('[data-chile-fields]').hidden = !enabled;
          component.querySelector('[data-chile-destination]').value = enabled ? 'Yes' : 'No';
        });
      }
      save() {
        const attributes = { 'Delivery to Chile': this.toggle.checked ? 'Yes' : 'No', RUT: this.toggle.checked ? this.rut.value.trim().toUpperCase() : '' };
        const write = async () => {
          const response = await fetch(this.dataset.updateUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes })
          });
          if (!response.ok) throw new Error('Cart update failed');
          this.querySelector('[data-chile-error]').hidden = true;
        };
        const queued = (window.spyChileRutSave || Promise.resolve()).catch(() => {}).then(write);
        window.spyChileRutSave = queued;
        return queued.catch(error => { this.showError(); throw error; });
      }
      showError() {
        const error = this.querySelector('[data-chile-error]');
        error.textContent = this.dataset.saveError;
        error.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-international-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-international-delivery')) {
    customElements.define('cart-international-delivery', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.form = this.closest('form');
        this.country = this.querySelector('[data-delivery-country]');
        this.keys = JSON.parse(this.querySelector('[data-delivery-keys]').textContent);
        this.addEventListener('input', () => this.sync(), options);
        this.addEventListener('change', () => {
          this.sync();
          this.save().catch(() => {});
        }, options);
        this.form.addEventListener('submit', async event => {
          if (this.ready) { this.ready = false; return; }
          event.preventDefault();
          if (this.pendingSubmit) return;
          this.sync();
          if (!this.form.reportValidity()) return;
          this.pendingSubmit = true;
          try {
            await this.save();
            this.ready = true;
            this.form.requestSubmit(event.submitter || undefined);
          } catch { this.showError(); }
          finally { this.pendingSubmit = false; }
        }, options);
        this.form.querySelectorAll('a').forEach(link => {
          if (new URL(link.href, location.href).pathname === new URL(this.form.action).pathname) {
            link.addEventListener('click', async event => {
              event.preventDefault();
              try { await this.save(); location.assign(link.href); }
              catch { this.showError(); }
            }, options);
          }
        });
        this.sync();
      }
      disconnectedCallback() { this.controller.abort(); }
      normalize(input) {
        let value = input.value.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, c => String(c.charCodeAt(0) & 15));
        if (input.dataset.normalize === 'digits') value = value.replace(/[\s.\-]/g, '');
        if (input.dataset.normalize === 'code') value = value.replace(/\s/g, '').toUpperCase();
        if (input.dataset.normalize === 'document') value = value.toUpperCase();
        if (input.dataset.normalize === 'postal') value = value.replace(/\s/g, '');
        if (input.dataset.normalize === 'phone') {
          value = value.replace(/[\s()\-]/g, '');
          const prefix = input.dataset.prefix;
          if (value.startsWith('+' + prefix)) value = value.slice(prefix.length + 1);
          else if (value.startsWith('00' + prefix)) value = value.slice(prefix.length + 2);
          else if (value.startsWith(prefix) && value.length > 9) value = value.slice(prefix.length);
          if (prefix === '966' && value.startsWith('0')) value = value.slice(1);
        }
        input.value = value;
      }
      applyCountry() {
        const country = this.country.value;
        this.dataset.country = country;
        this.toggleAttribute('data-special-destination', country !== 'OTHER');
        this.querySelectorAll('[data-country-group]').forEach(group => {
          const enabled = group.dataset.countryGroup === country;
          group.hidden = !enabled;
          group.disabled = !enabled;
          const type = group.querySelector('[data-document-type]');
          const number = group.querySelector('[data-document-number]');
          const option = type.selectedOptions[0];
          number.dataset.normalize = option.dataset.normalize;
          if (option.dataset.pattern) number.pattern = option.dataset.pattern;
          else number.removeAttribute('pattern');
          group.querySelector('[data-document-format]').textContent = option.dataset.format;
          group.querySelectorAll('input').forEach(input => {
            input.required = enabled && input.dataset.required === 'true';
            this.normalize(input);
            input.setCustomValidity('');
            if (enabled && input.required && !input.value.trim()) input.setCustomValidity(this.dataset.requiredMessage);
            else if (enabled && input.validity.patternMismatch) input.setCustomValidity(this.dataset.invalidMessage);
          });
        });
        this.querySelectorAll('[data-native-country]').forEach(el => { el.hidden = el.dataset.nativeCountry !== country; });
        this.querySelector('[data-legacy-chile]').value = country === 'CL' ? 'Yes' : 'No';
        const rut = this.querySelector('[data-country-group="CL"] [data-document-number]');
        const type = this.querySelector('[data-country-group="CL"] [data-document-type]');
        this.querySelector('[data-legacy-rut]').value = country === 'CL' && type.value === 'RUT' ? rut.value.trim() : '';
      }
      sync() {
        this.applyCountry();
        const values = new Map(Array.from(this.querySelectorAll('[data-attribute]')).map(input => [input.dataset.attribute, input.value]));
        document.querySelectorAll('cart-international-delivery').forEach(component => {
          if (component === this || !component.country) return;
          component.country.value = this.country.value;
          component.querySelectorAll('[data-attribute]').forEach(input => { input.value = values.get(input.dataset.attribute) || ''; });
          component.applyCountry();
        });
      }
      save() {
        const attributes = Object.fromEntries(this.keys.map(key => [key, '']));
        this.querySelectorAll('[data-country-group]:not([disabled]) [data-attribute]').forEach(input => {
          attributes[input.dataset.attribute] = input.value.trim();
        });
        attributes['Delivery destination'] = this.country.value;
        attributes['Delivery to Chile'] = this.querySelector('[data-legacy-chile]').value;
        attributes.RUT = this.querySelector('[data-legacy-rut]').value;
        const write = async () => {
          const response = await fetch(this.dataset.updateUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes })
          });
          if (!response.ok) throw new Error('Cart update failed');
          this.querySelector('[data-delivery-error]').hidden = true;
        };
        const queued = (window.spyInternationalDeliverySave || Promise.resolve()).catch(() => {}).then(write);
        window.spyInternationalDeliverySave = queued;
        return queued.catch(error => { this.showError(); throw error; });
      }
      showError() {
        const error = this.querySelector('[data-delivery-error]');
        error.textContent = this.dataset.saveError;
        error.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
